import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    padding-top: 32px;
    flex-direction: column;
    min-height: 100vh ;
  `,
  horizontalPadding: css`
    padding: 0px 16px;
  `,
  background: {
    school: css`
      background: ${colors.platinum};
    `,
    community: css`
      background: ${colors.prussian200};
    `,
  },
  searchBar: css`
    &.MuiOutlinedInput-root {
      font-size: 13px;
      font-family: 'Proxima Nova';
      padding-left: 10px;
    }
    & > .MuiOutlinedInput-input {
      padding: 7.5px 0px;
    }
    & > .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${colors.prussian600};
      border-radius: 10px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3),
        0px 1px 3px 1px rgba(0, 0, 0, 0.15);
    }
  `,
  iconSearch: css`
    color: ${colors.prussianMid} !important;
  `,
  footerIllustration: css`
    object-fit: cover;
    width: 100%;
    margin-top: 88px;
  `,
};

export default styles;
